import { render } from "./GradesSection.vue?vue&type=template&id=9df64cc0&scoped=true"
const script = {}

import "./GradesSection.vue?vue&type=style&index=0&id=9df64cc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9df64cc0"]])

export default __exports__